export default function Heading({ light = false, children }) {
  const colorClasses = light ? 'text-gray-600' : 'text-gray-700';
  return (
    <h3 className={`text-sm md:text-base lg:text-lg font-semibold ${colorClasses}`}>
      {children}
    </h3>
  );
}
